module.exports = __webpack_public_path__ + "img/two.4221c41e.png";